import { Configuration, RedirectRequest } from '@azure/msal-browser';
import publicClientApplication from './publicClientApplication';

const clientId = import.meta.env.VITE_MSAL_CLIENT_ID;
const authority = import.meta.env.VITE_MSAL_AUTHORITY;
const redirectUri = import.meta.env.VITE_MSAL_REDIRECT_URI;

export const configuration: Configuration = {
  auth: {
    clientId,
    authority,
    redirectUri,
  },
  cache: {
    cacheLocation: 'sessionStorage',
  },
};

export function checkIsAuthenticated(): boolean {
  const accounts = publicClientApplication.getAllAccounts();
  return accounts && accounts.length > 0;
}

export const apiRequest: RedirectRequest = {
  scopes: [`api://${clientId}/default`, 'openid', 'profile'],
};

export const graphRequest = {
  scopes: [
    'User.Read',
    'User.Read.All',
    'User.ReadBasic.All',
    'Files.Read.All',
    'Files.Read',
    'Sites.Read.All',
    'People.Read',
    'GroupMember.Read.All',
  ],
};
